export const blockIconsPhotoandimageCircleNew = (
	<span className='material-symbols-outlined'>circle</span>
);
